"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const FilterChip_1 = require("./FilterChip");
const constants_1 = require("../../../constants");
const WrapperContainer = (0, material_1.styled)("div")(() => ({
    display: "flex",
    flexWrap: "wrap",
}));
const FiltersContainer = (0, material_1.styled)("div")(() => ({
    display: "flex",
    alignItems: "center",
}));
const ConjuntionLabel = (0, material_1.styled)(material_1.Typography)(() => ({
    fontWeight: "bold",
}));
const FilterPills = ({ conjunction = constants_1.Conjunction.AND, deletable = true, filters, onDelete = () => { }, currentYear, }) => (react_1.default.createElement(WrapperContainer, { "data-testid": "FilterPills_root" }, filters.map(({ operator, label, value, active, category }, index) => {
    let displayLabel = label;
    if (category === "RAF_SCORE_CURRENT_YEAR") {
        displayLabel = `${label} (${currentYear})`;
    }
    if (category === "RAF_SCORE_PRIOR_YEAR") {
        displayLabel = `${label} (${currentYear - 1})`;
    }
    if (category === "RAF_SCORE_2_YEARS_PRIOR") {
        displayLabel = `${label} (${currentYear - 2})`;
    }
    return (react_1.default.createElement(FiltersContainer, { key: index, "data-testid": "filters_container" },
        react_1.default.createElement(FilterChip_1.FilterChip, { active: active, deletable: deletable, id: index, label: displayLabel, value: value, onDelete: () => {
                onDelete(index);
            }, operator: operator }),
        index < filters.length - 1 && (react_1.default.createElement(ConjuntionLabel, { variant: "overline" }, conjunction))));
})));
exports.default = FilterPills;
